import React from 'react';
import { InternalAuditorTemplate } from '../components/training/templates/InternalAuditorTemplate';
import { getStandardBySlug } from '../data/standards/standardsData';
import { getInternalAuditorContent } from '../data/standards/trainingContent';

export const ISO45001InternalAuditor = () => {
  const standard = getStandardBySlug('iso-45001');
  const content = getInternalAuditorContent('iso-45001');

  return <InternalAuditorTemplate standard={standard} content={content} />;
};
